import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "fixed-control"
};
const _hoisted_2 = {
  class: "qty-input"
};
const _hoisted_3 = {
  key: 0,
  class: ""
};
const _hoisted_4 = {
  class: "hide-mobile"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "c-button-group"
};
const _hoisted_7 = {
  class: "hide-mobile"
};
const _hoisted_8 = {
  key: 0,
  class: "iconfont icon-mail-fill"
};
const _hoisted_9 = {
  key: 1,
  class: "iconfont icon-quit"
};
const _hoisted_10 = {
  key: 2,
  class: "iconfont icon-hear-full"
};
const _hoisted_11 = {
  key: 3,
  class: "iconfont icon-file-download"
};
const _hoisted_12 = {
  key: 4,
  class: "iconfont icon-upload"
};
const _hoisted_13 = {
  key: 5,
  class: "iconfont icon-invoice"
};
const _hoisted_14 = {
  key: 6,
  class: "iconfont icon-cart-plus"
};
const _hoisted_15 = {
  key: 7,
  class: "iconfont icon-reset"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 0,
  class: "nested-dropdown-container"
};
const _hoisted_18 = {
  key: 0,
  class: "iconfont icon-cart-plus"
};
const _hoisted_19 = {
  key: 1,
  class: "iconfont icon-mail-fill"
};
const _hoisted_20 = {
  key: 2,
  class: "iconfont icon-quit"
};
const _hoisted_21 = {
  key: 3,
  class: "iconfont icon-hear-full"
};
const _hoisted_22 = {
  key: 4,
  class: "iconfont icon-file-download"
};
const _hoisted_23 = {
  key: 5,
  class: "iconfont icon-upload"
};
const _hoisted_24 = {
  key: 6,
  class: "iconfont icon-invoice"
};
const _hoisted_25 = {
  key: 7,
  class: "iconfont icon-reset"
};
const _hoisted_26 = {
  class: "hide-mobile"
};
import { ref } from "vue";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { checkGetDatasheetPermission, isQuantityChanging, onQuantityChanged, quantity, moreButtons, primaryButton, handleButton, priceInformation } from "../hooks/summary";
import { getCurrentInstance } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'productFixedBottom',
  setup(__props) {
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    const additionalStore = useAdditionalAttrStore();
    const dataConfig = additionalStore.getDataConfig;
    const openToggleMenu = el => {
      el.stopPropagation();
      el?.preventDefault();
      const that = el.currentTarget;
      that?.classList.toggle("active");
      const content = that?.nextElementSibling;
      if (content instanceof HTMLElement) {
        if (content.style.maxHeight) {
          content.style.maxHeight = "";
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      }
    };
    let timeout = null;
    const qty = ref(quantity.value);
    const debounce = (func, wait) => {
      return (...args) => {
        if (timeout !== null) {
          clearTimeout(timeout);
        }
        eventBus.emit("mobileQtyChanged", args[0]);
        timeout = setTimeout(() => {
          func(...args);
        }, wait);
      };
    };
    eventBus.on("pcQtyChanged", item => {
      qty.value = item;
    });
    const debounceOnqtychanges = debounce(onQuantityChanged, 800);
    return (_ctx, _cache) => {
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_link = _resolveComponent("el-link");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_input_number, {
        modelValue: qty.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => qty.value = $event),
        min: _unref(dataConfig).minQty || 1,
        max: _unref(dataConfig).maxQty,
        id: "mobile-qty",
        onChange: _unref(debounceOnqtychanges)
      }, null, 8, ["modelValue", "min", "max", "onChange"]), _unref(dataConfig).showPricing ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("strong", null, _toDisplayString(_ctx.$t("label.total")), 1), _createElementVNode("label", _hoisted_4, [_createTextVNode(_toDisplayString(_ctx.$t("label.exclVat")) + " ", 1), _unref(dataConfig).shippingDetailUrl ? (_openBlock(), _createElementBlock("span", _hoisted_5, [_cache[3] || (_cache[3] = _createTextVNode("& ", -1)), _createVNode(_component_el_link, {
        type: "primary",
        target: "_blank",
        href: _unref(dataConfig).shippingDetailUrl
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("link.shipping")), 1)]),
        _: 1
      }, 8, ["href"])])) : _createCommentVNode("", true)]), _createElementVNode("strong", null, _toDisplayString(_unref(priceInformation).totalPrice), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, _unref(isQuantityChanging)]]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_dropdown, {
        class: "control-dropdown",
        trigger: "click",
        "popper-class": "configurator-dropdown"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "configurator-dropdown-options"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moreButtons), (item, key) => {
            return _openBlock(), _createBlock(_component_el_dropdown_item, {
              key: key,
              divided: item.showSeparatorAbove,
              class: _normalizeClass(item.isMenu ? 'menuclass ' + item.class : item.class),
              disabled: item.isMenu ? false : _unref(checkGetDatasheetPermission)(item),
              onClick: $event => item.isMenu ? '' : _unref(handleButton)(item, _unref(eventBus))
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "nested-dropdown-value",
                onClick: _cache[1] || (_cache[1] = $event => openToggleMenu($event))
              }, [_createElementVNode("div", null, [item.icon === 'e-mail' ? (_openBlock(), _createElementBlock("i", _hoisted_8)) : _createCommentVNode("", true), item.icon === 'quit' ? (_openBlock(), _createElementBlock("i", _hoisted_9)) : _createCommentVNode("", true), item.icon === 'heart' ? (_openBlock(), _createElementBlock("i", _hoisted_10)) : _createCommentVNode("", true), item.icon === 'download' ? (_openBlock(), _createElementBlock("i", _hoisted_11)) : _createCommentVNode("", true), item.icon === 'upload' ? (_openBlock(), _createElementBlock("i", _hoisted_12)) : _createCommentVNode("", true), item.icon === 'invoice' ? (_openBlock(), _createElementBlock("i", _hoisted_13)) : _createCommentVNode("", true), item.icon === 'cart' ? (_openBlock(), _createElementBlock("i", _hoisted_14)) : _createCommentVNode("", true), item.icon === 'reset' ? (_openBlock(), _createElementBlock("i", _hoisted_15)) : _createCommentVNode("", true), item.icon === 'compass' ? (_openBlock(), _createBlock(_component_svg_icon, {
                key: 8,
                "icon-class": "compass-drafting"
              })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.label), 1)]), item.isMenu ? (_openBlock(), _createElementBlock("span", _hoisted_16, [_createVNode(_component_svg_icon, {
                "icon-class": "chevron-down-blue"
              })])) : _createCommentVNode("", true)]), item.isMenu ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_scrollbar, {
                height: "90px"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_menu, {
                  mode: "vertical"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childs, (child, key) => {
                    return _openBlock(), _createBlock(_component_el_menu_item, {
                      disabled: _unref(checkGetDatasheetPermission)(child),
                      onClick: $event => _unref(handleButton)(child, _unref(eventBus)),
                      key: key
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(child.label), 1)]),
                      _: 2
                    }, 1032, ["disabled", "onClick"]);
                  }), 128))]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["divided", "class", "disabled", "onClick"]);
          }), 128))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary"
        }, {
          default: _withCtx(() => [_createVNode(_component_svg_icon, {
            "icon-class": "more-options"
          }), _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("button.moreOptions")), 1)]),
          _: 1
        })]),
        _: 1
      }), _unref(primaryButton) ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "info",
        class: "wikaButtonConf",
        "data-colour": _unref(primaryButton).class ? _unref(primaryButton).class : 'blue',
        disabled: _unref(checkGetDatasheetPermission)(_unref(primaryButton), true),
        onClick: _cache[2] || (_cache[2] = $event => _unref(checkGetDatasheetPermission)(_unref(primaryButton), true) ? '' : _unref(handleButton)(_unref(primaryButton), _unref(eventBus), true))
      }, {
        default: _withCtx(() => [_unref(primaryButton).icon === 'cart' ? (_openBlock(), _createElementBlock("i", _hoisted_18)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'e-mail' ? (_openBlock(), _createElementBlock("i", _hoisted_19)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'quit' ? (_openBlock(), _createElementBlock("i", _hoisted_20)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'heart' ? (_openBlock(), _createElementBlock("i", _hoisted_21)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'download' ? (_openBlock(), _createElementBlock("i", _hoisted_22)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'upload' ? (_openBlock(), _createElementBlock("i", _hoisted_23)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'invoice' ? (_openBlock(), _createElementBlock("i", _hoisted_24)) : _createCommentVNode("", true), _unref(primaryButton).icon === 'reset' ? (_openBlock(), _createElementBlock("i", _hoisted_25)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(primaryButton).label), 1)]),
        _: 1
      }, 8, ["data-colour", "disabled"])) : _createCommentVNode("", true)])]);
    };
  }
});